import { getPlatformApiParams } from '../../shared/api/platform-api';

const GET_PLATFORM_LIST_REQUEST_CALLED = 'GET_PLATFORM_LIST_REQUEST_CALLED';
const GET_PLATFORM_LIST_SUCCEEDED = 'GET_PLATFORM_LIST_SUCCEEDED';
const GET_PLATFORM_LIST_FAILED = 'GET_PLATFORM_LIST_FAILED';

export const getPlatform = () => ({
    type: GET_PLATFORM_LIST_REQUEST_CALLED,
    actionTypes: {
        success: GET_PLATFORM_LIST_SUCCEEDED,
        fail: GET_PLATFORM_LIST_FAILED,
    },
    config: getPlatformApiParams(),
});

const initialState = {
    loadState: 'loading',
    data: [],
    error: null,
};

export const platformReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_PLATFORM_LIST_REQUEST_CALLED:
        return {
            ...state,
            loadState: 'loading',
            data: [],
            error: null,
        };
    case GET_PLATFORM_LIST_SUCCEEDED:
        return {
            ...state,
            loadState: 'success',
            data: action.payload.data,
            error: null,
        };
    case GET_PLATFORM_LIST_FAILED:
        return {
            ...state,
            loadState: 'fail',
            data: [],
            error: action.payload,

        };
    default:
        return state;
    }
};
